
































































import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import moment from "moment";
import {
  CombinedClaimReceiptStatusMap,
  HsabExpenseByExternalIdRequest,
  HsabExpenseResponse,
  HsabTransactionDetail,
} from "@/shared/types";
import { wexClaimReceiptStatusIcon } from "@/shared/awesomeIconMapper";
import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import HsabTransactionChildRow from "@/shared/components/cash/hsabank/HsabTransactionChildRow.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useNotifierStore } from "@/shared/store/notifier";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import HsabExpenseDetailsModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    HsabTransactionChildRow,
    Pill,
    CurrencyAmount,
    HsabExpenseEditModal,
    HsabExpenseDetailsModal,
  }
})
export default class HsabTransactionListItem extends Vue {
  hsabExpenseStore = useHsabExpenseStore();
  notifierStore = useNotifierStore();
  custodianSettingsStore = useCustodianSettingsStore();
  wexClaimReceiptStatusIcon = wexClaimReceiptStatusIcon;
  CombinedClaimReceiptStatusMap = CombinedClaimReceiptStatusMap;
  flagStore = useFeatureFlagStore();

  @Prop()
  transaction: HsabTransactionDetail;

  @Prop()
  isNotional: boolean;

  isOpen = false;
  expense: HsabExpenseResponse = null;
  showDetailsModal = false;
  showEditModal = false;
  thinking = false;

  toggleOpen (): void {
    this.isOpen = !this.isOpen;
  }

  get getPillType (): string {
    if (this.transaction.creditDebitIndicator === "C") {
      return "green-bg";
    }
    return "red-bg";
  }

  get showStatusPill () {
    return !this.transaction.isPosted;
  }

  get formattedDate (): string {
    const date = this.transaction.isPosted ? this.transaction.postingDate : this.transaction.effectiveDate;
    return moment(date).format("MMM D, YYYY");
  }

  get isCredit () {
    return this.transaction.creditDebitIndicator === "C";
  }

  get isDebit () {
    return this.transaction.creditDebitIndicator === "D";
  }

  get currencyClasses () {
    let result = "text-center pr-0 w-100 font-size-corection";
    if (this.transaction.creditDebitIndicator === "NA") {
      result = "text-center pr-0 w-100 font-size-corection color-grey";
    } else if (this.isDebit) {
      result = "text-center pr-0 w-100 font-size-corection color-red";
    }
    return [result];
  }
  showViewExpenseButton () {
    return this.flagStore.flags.bend19778ViewExpenseButtonInTransactions && (this.hasFlowId || this.hasClaimNumber);
  }
  hasFlowId () {
    return this.transaction && this.transaction.flowId;
  }
  hasClaimNumber () {
    return this.transaction && this.transaction.claimNumber;
  }
  async loadExpenseByExternalId () {
    this.thinking = true;
    const request: HsabExpenseByExternalIdRequest = {
      externalReimbursementId: this.hasClaimNumber() ? this.transaction.claimNumber : null,
      externalTransactionId: this.hasFlowId() ? this.transaction.flowId : null,
    };
    this.expense = await this.hsabExpenseStore.loadExpenseByExternalId(request);
    this.thinking = false;
    if (!this.expense) {
      this.notifierStore.setDanger("This Expense was not found");
      return;
    }
    if (this.transaction.isPosted) {
      this.showDetailsModal = true;
    } else {
      this.showEditModal = true;
    }
  }
  onCloseEditEvent () {
    this.showEditModal = false;
  }
  onCloseDetailsEvent () {
    this.showDetailsModal = false;
  }
}
